"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var styled_components_1 = __importDefault(require("styled-components"));
var tokens_1 = __importDefault(require("@paprika/tokens"));
var stylers_1 = __importDefault(require("@paprika/stylers"));
var collapsible_1 = __importDefault(require("@paprika/collapsible"));
var SectionWrapper = styled_components_1.default(collapsible_1.default)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding: ", ";\n  border-bottom: 1px solid ", ";\n\n  .collapsible__label {\n    font-weight: 700;\n  }\n"], ["\n  padding: ", ";\n  border-bottom: 1px solid ", ";\n\n  .collapsible__label {\n    font-weight: 700;\n  }\n"])), stylers_1.default.spacer(3), tokens_1.default.color.blackLighten60);
exports.default = SectionWrapper;
var templateObject_1;
//# sourceMappingURL=Section.styles.js.map